<script setup lang="ts">
import { computed } from 'vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { formatDocumentReadTime } from '@/js/account/entities/document';
import { classNames } from '@/js/lib/bem';

const props = defineProps<{
  readMinutes: number | null | undefined
}>();

const cn = classNames('document-read-time');

const label = computed(() => formatDocumentReadTime(props.readMinutes));
</script>

<template>
  <div :class="cn()">
    <BaseIcon name="clock" :width="16" :height="16" :class="cn('icon')" />
    <span :class="cn('label')">{{ label }}</span>
  </div>
</template>

<style lang="scss" scoped>
.document-read-time {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 1.2;
  color: var(--color-accent);

  &__icon {
    flex-shrink: 0;
  }
}
</style>
